"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncPrivateMemoButton = exports.SyncPrivateMemoButtonRaw = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var withState_1 = require("../hocs/withState");
var i18n_1 = __importDefault(require("../i18n"));
var util_1 = require("../util");
var SyncPrivateMemoButtonRaw = function (_a) {
    var _b;
    var syncingPrivateMemoUserModel = _a.syncingPrivateMemoUserModel, setSyncingPrivateMemoUserModel = _a.setSyncingPrivateMemoUserModel, syncPrivateMemo = _a.syncPrivateMemo, user = _a.user, fromVrChatCom = _a.fromVrChatCom, notesLoading = _a.notesLoading;
    var canSync = fromVrChatCom || (0, util_1.canSyncToVRC)((_b = user.profile) === null || _b === void 0 ? void 0 : _b.privateMemo);
    return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { color: "orange", size: "mini", style: { display: "block" }, onClick: function () {
            return setSyncingPrivateMemoUserModel({ userId: user.id, note: fromVrChatCom ? user.note : undefined });
        }, disabled: !!syncingPrivateMemoUserModel || syncPrivateMemo || !canSync || notesLoading, children: canSync ? i18n_1.default.syncPrivateMemoByThis : i18n_1.default.syncPrivateMemoTooLong }));
};
exports.SyncPrivateMemoButtonRaw = SyncPrivateMemoButtonRaw;
exports.SyncPrivateMemoButton = (0, withState_1.withState)()([
    "syncingPrivateMemoUserModel",
    "setSyncingPrivateMemoUserModel",
    "syncPrivateMemo",
    "notesLoading",
]).memoFC(exports.SyncPrivateMemoButtonRaw);
